import { Popover, PopoverBody, PopoverContent, PopoverProps, PopoverTrigger, Portal } from '@chakra-ui/react';
import { FC, Fragment, ReactNode } from 'react';

interface ILectureSearchCardPopoverProps extends PopoverProps {
  isDisabled?: boolean;
  triggerSlot: ReactNode;
  bodySlot: ReactNode;
}

export const LectureSearchCardPopover: FC<ILectureSearchCardPopoverProps> = ({
  triggerSlot,
  bodySlot,
  isDisabled,
  ...rest
}) => {
  if (isDisabled) {
    return <Fragment>{triggerSlot}</Fragment>;
  }

  return (
    <Popover trigger="hover" openDelay={1000} {...rest}>
      <PopoverTrigger>{triggerSlot}</PopoverTrigger>
      <Portal>
        <PopoverContent bg="white" border="0" boxShadow="popover" maxW="400px" p={2} borderRadius={0}>
          <PopoverBody>{bodySlot}</PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
